import { selectErrorMessages } from "../../slices/error.slice";
import { useAppSelector } from "../../storeHooks";

function Message(props: { message: string }) {
  return <p>{props.message}</p>;
}

export default function Error() {
  const messages = useAppSelector(selectErrorMessages);

  if (!messages) return null;
  if (messages.length === 0) return null;

  return (
    <section data-type="section" className="space-y-4">
      <div className="border w-full p-2 h-16">
        <p>Error Messages:</p>
        <ul className=" text-red-900">
          {messages.map((m) => (
            <Message message={m} key="key" />
          ))}
        </ul>
      </div>
    </section>
  );
}
